var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxUserVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-user-voice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5781 16.1801C24.5781 20.7401 21.1381 24.1801 16.5781 24.1801C12.0181 24.1801 8.57812 20.7401 8.57812 16.1801C8.57812 11.6201 12.0181 8.18015 16.5781 8.18015C21.1381 8.18015 24.5781 11.6201 24.5781 16.1801ZM20.5781 16.1801C20.5781 13.8241 18.9341 12.1801 16.5781 12.1801C14.2221 12.1801 12.5781 13.8241 12.5781 16.1801C12.5781 18.5361 14.2221 20.1801 16.5781 20.1801C18.9341 20.1801 20.5781 18.5361 20.5781 16.1801ZM4.57812 36.1801C4.57812 30.6661 9.06413 26.1801 14.5781 26.1801H18.5781C24.0921 26.1801 28.5781 30.6661 28.5781 36.1801V38.1801H24.5781V36.1801C24.5781 32.8721 21.8861 30.1801 18.5781 30.1801H14.5781C11.2701 30.1801 8.57812 32.8721 8.57812 36.1801V38.1801H4.57812V36.1801ZM34.4781 8.28015L37.3061 5.45215C40.7061 8.85415 42.5781 13.3741 42.5781 18.1801C42.5781 22.9861 40.7061 27.5061 37.3061 30.9081L34.4781 28.0801C37.1201 25.4341 38.5781 21.9181 38.5781 18.1801C38.5781 14.4421 37.1201 10.9261 34.4781 8.28015ZM28.8201 13.9402L31.6481 11.1082C33.5361 12.9962 34.5781 15.5062 34.5781 18.1802C34.5781 20.8542 33.5361 23.3642 31.6481 25.2522L28.8201 22.4202C29.9541 21.2902 30.5781 19.7842 30.5781 18.1802C30.5781 16.5762 29.9541 15.0702 28.8201 13.9402Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxUserVoice);
export default __webpack_public_path__ + "static/media/bx-user-voice.529f3e58d6e43e921a8343c686d7b02e.svg";
export { ForwardRef as ReactComponent };